__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "patterns";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@plone/registry", "2.7.0", () => (__webpack_require__.e(6176).then(() => (() => (__webpack_require__(6176))))));
			register("backbone.paginator", "2.0.8", () => (Promise.all([__webpack_require__.e(65541), __webpack_require__.e(40705), __webpack_require__.e(95722)]).then(() => (() => (__webpack_require__(65541))))));
			register("backbone", "1.6.0", () => (Promise.all([__webpack_require__.e(21391), __webpack_require__.e(35686), __webpack_require__.e(40705)]).then(() => (() => (__webpack_require__(21391))))));
			register("backbone", "1.6.1", () => (Promise.all([__webpack_require__.e(42627), __webpack_require__.e(35686), __webpack_require__.e(40705)]).then(() => (() => (__webpack_require__(42627))))));
			register("bootstrap", "5.3.8", () => (() => (__webpack_require__(32603))), 1);
			register("dropzone", "5.9.3", () => (__webpack_require__.e(62628).then(() => (() => (__webpack_require__(62628))))));
			register("dropzone", "6.0.0-beta.2", () => (__webpack_require__.e(56284).then(() => (() => (__webpack_require__(56284))))));
			register("jqtree", "1.8.10", () => (__webpack_require__.e(31144).then(() => (() => (__webpack_require__(31144))))));
			register("jquery-form", "4.3.0", () => (Promise.all([__webpack_require__.e(35686), __webpack_require__.e(64061)]).then(() => (() => (__webpack_require__(64061))))));
			register("jquery", "3.7.1", () => (() => (__webpack_require__(74692))), 1);
			register("js-cookie", "3.0.5", () => (__webpack_require__.e(18987).then(() => (() => (__webpack_require__(18987))))));
			register("moment", "2.30.1", () => (__webpack_require__.e(95093).then(() => (() => (__webpack_require__(95093))))));
			register("pikaday", "1.8.2", () => (Promise.all([__webpack_require__.e(78823), __webpack_require__.e(38761)]).then(() => (() => (__webpack_require__(78823))))));
			register("select2", "3.5.4", () => (__webpack_require__.e(42087).then(() => (() => (__webpack_require__(44275))))));
			register("sortablejs", "1.15.6", () => (__webpack_require__.e(10246).then(() => (() => (__webpack_require__(10246))))));
			register("tippy.js", "6.3.7", () => (__webpack_require__.e(64504).then(() => (() => (__webpack_require__(64504))))));
			register("underscore", "1.13.7", () => (__webpack_require__.e(4523).then(() => (() => (__webpack_require__(4523))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};